import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { ILearningCenterCategoryTileFields } from '../../../../../types/contentful';
import { getCategorySlug } from '../shared';
import areaIcon from '@/images/icon-area.svg';
import barsIcon from '@/images/icon-bars.svg';
import { LinearGradientToken } from '../../../../theme/tokens/linear-gradient';
import { useTheme } from '../../../../theme';
import { Theme } from '../../../../theme/types';
import Link from '../../../Link';

interface CategoryTileProps extends ILearningCenterCategoryTileFields {
  color: LinearGradientToken;
}

function getGradientStyle(color: LinearGradientToken, theme: Theme) {
  const colors = theme.linearGradient[color];
  return {
    background: `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 100%)`
  };
}

export function CategoryTile({
  title,
  icon,
  category,
  color
}: CategoryTileProps) {
  const router = useRouter();
  const theme = useTheme();
  const href = router.asPath.includes('learning-center')
    ? `/learning-center/${getCategorySlug(category)}`
    : `/partner-resources/${getCategorySlug(category)}`;
  const image = icon === 'Area' ? areaIcon : barsIcon;
  const IMAGE_SIZE = 64;

  return (
    <div
      className="h-[16.8125rem] w-full max-w-[12rem] rounded-[1.5rem] transition-[transform,height,margin,box-shadow] duration-200 ease-in-out will-change-[transform,margin,box-shadow] hover:scale-[1.08] hover:shadow-[0_8px_25px_0_rgba(29,37,44,0.16)] desktop:relative desktop:h-[17.5rem] desktop:max-w-none desktop:text-[1.625rem] desktop:hover:scale-[1.11] desktop:hover:[&:has(*)]:mx-0"
      style={getGradientStyle(color, theme)}
      data-testid="category-tile"
    >
      <Link
        href={href}
        className="flex h-full w-full flex-col content-start justify-between p-4 text-[1.375rem] font-normal capitalize text-white desktop:font-light [&>span]:!w-16"
      >
        <Image alt="" src={image} width={IMAGE_SIZE} height={IMAGE_SIZE} />
        <div className="line-clamp-2 overflow-hidden [text-overflow:ellipsis]">
          {title}
        </div>
      </Link>
    </div>
  );
}
